module.exports = __webpack_public_path__ + "static/Optiplex3-ab623158659c1192f047cd055e409ab4.png";